import Api from "repository/Api"

/**
 * Get the base details and data for a given map (hash)
 * @param {string} mapId
 */
export const getMap = async (mapId) => {
    const res = await Api.get(`/project_code_names/${mapId}/sw-format`);
    return res.data;
};

//modified

export const isMapModified = async (mapId) => {
    const res = await Api.get(`/project_code_names/${mapId}/sw-format-modified`)
    return res.data.swModified;
};

export const getMapModified = async (mapId) => {
    const res = await Api.get(`/project_code_names/${mapId}/sw-format-modified`)
    return res.data;
};

/**
 * Set the data axis of modified map
 * @param {string} mapId - The id of the map
 * @param {Table} mapModified
 * @returns {Promise<void>}
 */
export const setMapModified = async (mapId, mapModified) => {
    const data = {modified: mapModified}
    const config = {
        headers: {"Content-Type": "application/merge-patch+json"}
    }
    await Api.patch(`/project_code_names/${mapId}/save-change`, data, config);
};

/**
 * Set x/y axis of the modified map
 * @param {string} mapId - The id of the map
 * @param {string} axisId - The id of the axis
 * @param {Axis} mapModifiedAxis - The new axis data to set
 * @returns {Promise<string[]>} affectedMapIds - The ids of all maps affected by axis edit
 */
export const setMapModifiedAxis = async (mapId, axisId, mapModifiedAxis) => {
    const data = {axis: axisId, modified: mapModifiedAxis}
    const config = {
        headers: {"Content-Type": "application/merge-patch+json"}
    }
    const res = await Api.patch(`/project_code_names/${mapId}/save-axis`, data, config);
    return res.data["code-names-affected"];
};

//favourited

/**
 * Toggle the favourited field on a map
 * @param {string} mapId - The id of the map
 * @returns {Promise<boolean>} isFavourited - Whether the map is favourited after the toggle
 */
export const toggleMapFavourited = async (mapId) => {
    const data = {};
    const config = {
        headers: {"Content-Type": "application/merge-patch+json"}
    }
    const res = await Api.patch(`/project_code_names/${mapId}/toggle-favourite`, data, config);
    return res.data.isFavourited;
};

//undo

/**
 * Get every available undo state that a map can be reverted to
 * @param {string} mapId - The id of the map
 * @returns {Promise<string[]>} versionIds - The id of each undo state available
 */
export const getMapUndoVersions = async (mapId) => {
    const res = await Api.get(`/project_code_names/${mapId}/project_items_undos/?order[createdDate]=desc`);
    return res.data["hydra:member"].map(version => version.id);
};

/**
 * Revert a map to given undo state
 * @param {string} mapId - The id of the map (codename) the undo belongs to
 * @param {string} versionId - The id of the undo state
 * @returns {Promise<void>}
 */
export const applyMapUndo = async (mapId, versionId) => {
    const data = {};
    const config = {
        headers: {"Content-Type": "application/json"}
    }
    await Api.post(`/project_code_names/${mapId}/apply-undo/${versionId}`, data, config);
}